// import React from "react";
import "./EventOneAdvertismentPoster.scss";
const AdPoster = () => (
  <section className="banner">
    <div className="banner__overlay">
      <div className="banner__content">
        <div className="banner__left">
          <h1 className="banner__title">Discover Sports Events</h1>
          <p className="banner__subtitle">
            The best of live matches, local tournaments, and fan experiences.
          </p>
        </div>

        <div className="banner__right">
          <div className="banner__stores">
            <img
              src="./assets/img/play-store-icon.png"
              alt="Get it on Play Store"
              className="store-icon"
            />
            <img
              src="./assets/img/apple-store-icon.png"
              alt="Download on the App Store"
              className="store-icon"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default AdPoster;
